export const INITIAL_ITEM = 1;
export const MAX_ITEM = 10;
export const WIDTH_CELL_CURRENCY_EQUIVALENT = { xl: '326px', lg: '200px' };
export const WIDTH_CELL_SUGGESTION = '74px';
export const TTL_CLEAN_APPEARENCE = 3000;
export const PER_PAGE = 10;
